(function () {
  const $doc = $(document);
  const $body = $("body");

  if (!$body.length) return;

  const loginOpenSelector = 'a[data-target="login"], .top-nav-button-login, .top-nav-button-account, .customLoginPopup';
  const loginCloseSelector = ".login-widget .popup-widget-inner .close";

  function setLocked(value) {
    $body.data("loginPopupLocked", value === true);
  }

  function isLocked() {
    return $body.data("loginPopupLocked") === true;
  }

  function setAllowClose(value) {
    $body.data("loginPopupAllowClose", value === true);
  }

  function canClose() {
    return $body.data("loginPopupAllowClose") === true;
  }

  function stripLoginHoverBehavior() {
    $(loginOpenSelector).removeAttr("data-hover");
  }

  stripLoginHoverBehavior();
  $doc.on("ShoptetDOMCartContentLoaded ShoptetDOMSearchResultsLoaded", stripLoginHoverBehavior);

  $doc.off("click.loginPopupLock", loginOpenSelector).on("click.loginPopupLock", loginOpenSelector, function () {
    setLocked(true);
  });

  $doc.off("mousedown.loginPopupCloseGuard", loginCloseSelector).on("mousedown.loginPopupCloseGuard", loginCloseSelector, function () {
    setAllowClose(true);
  });

  $doc.off("click.loginPopupCloseGuard", loginCloseSelector).on("click.loginPopupCloseGuard", loginCloseSelector, function () {
    setAllowClose(true);
    setLocked(false);
    setTimeout(function () {
      setAllowClose(false);
    }, 0);
  });

  let previousVisible = $body.hasClass("login-window-visible");

  const observer = new MutationObserver(function () {
    let isVisible = $body.hasClass("login-window-visible");

    if (previousVisible && !isVisible && isLocked() && !canClose()) {
      if ($("#customerLogin, .login-widget .popup-widget-inner").length) {
        $body.addClass("user-action-visible login-window-visible");
        isVisible = true;
      } else {
        setLocked(false);
      }
    }

    previousVisible = isVisible;
  });

  observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
})();
